import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card';
import { ChatParticipant } from '@my-ipractice/types';
import { ChatParticipantProfilePicture } from './chat-participant-profile-picture';
import { ChatParticipantNameAndRole } from './chat-participant-name-and-role';

type Props = {
  participant: ChatParticipant;
};

export const ChatParticipantDetails = ({ participant }: Props) => {
  return (
    <HoverCard openDelay={200} closeDelay={200}>
      <HoverCardTrigger asChild>
        <div className="flex items-center space-x-2 hover:bg-slate-100 dark:hover:bg-slate-800 p-1 rounded-lg">
          <ChatParticipantProfilePicture participant={participant} />
          <ChatParticipantNameAndRole participant={participant} />
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        side="right"
        align="start"
        sideOffset={-200}
        className="min-w-fit flex flex-col items-center gap-2 text-center"
      >
        <ChatParticipantProfilePicture participant={participant} large />
        <ChatParticipantNameAndRole participant={participant} large />
      </HoverCardContent>
    </HoverCard>
  );
};
